export const socialMediaTeam = [
  {
    id: 1,
    name: 'Saloni Pokharna',
    teamName: 'Social Media',
    role: 'Lead',
    image: 'saloni_ix6kdb.jpg',
  },
  {
    id: 10,
    name: 'Yashi Jain',
    teamName: 'Social Media',
    role: 'Co-Lead',
    image: 'yashi-jain_k6gpjr.jpg',
  },
];

export const designTeam = [
  {
    id: 9,
    name: 'Mayank Jain',
    teamName: 'Design',
    role: 'Lead',
    image: 'mayank-jain_yx2mcw.jpg',
  },
  {
    id: 7,
    name: 'Arya Sankar Ram TS',
    teamName: 'Design',
    role: 'Co-Lead',
    image: 'arya_mrw77q.jpg',
  },
];

export const photographyTeam = [
  {
    id: 6,
    name: 'Sparsh Joshi',
    teamName: 'Photography',
    role: 'Lead',
    image: 'sparsh_ltdepx.jpg',
  },
  {
    id: 11,
    name: 'Daksh Dugar',
    teamName: 'Photography',
    role: 'Co-Lead',
    image: 'Daksh-Dugar_mhwarm.jpg',
  },
];

export const hrTeam = [
  {
    id: 3,
    name: 'Shreya Singh',
    teamName: 'HR',
    role: 'Lead',
    image: 'shreya_hapyd4.jpg',
  },
  {
    id: 2,
    name: 'Nandana P Bain',
    teamName: 'HR',
    role: 'Co-Lead',
    image: 'nandana_qhzfdx.jpg',
  },
];

export const contentTeam = [
  {
    id: 4,
    name: 'Lakshya Paneri',
    teamName: 'Content',
    role: 'Lead',
    image: 'lakshya_zgmqyf.jpg',
  },
];

export const PanelMembers = [
  {
    id: 4,
    name: 'Amaan',
    teamName: 'Panel Members',
    role: 'Vice President',
    image: 'aman_duiu2h.jpg',
  },
];

export const technicalTeam = [
  {
    id: 12,
    name: 'Sameer Chaudhary',
    teamName: 'Technical',
    role: 'Co-Lead',
    image: 'Team/WhatsApp Image 2025-11-24 at 10.42.20 PM.jpeg',
  },
];

export const eventManagementTeam = [
  {
    id: 5,
    name: 'Prakhar Sharma',
    teamName: 'Event Management',
    role: 'Lead',
    image: 'prakar_o4asjv.jpg',
  },
];

export const facultyCoordinator = [
  {
    id: 5,
    name: 'Dr. Velmurugan',
    teamName: 'Faculty Coordinator',
    role: 'Coordinator',
    image: 'velmurugansir_hpdqwt',
  },
];

export const TeamData = {
  socialMediaTeam,
  designTeam,
  photographyTeam,
  hrTeam,
  contentTeam,
  eventManagementTeam,
  facultyCoordinator,
  PanelMembers,
  technicalTeam,
};
